"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TypesCore = void 0;
exports.TypesCore = {
    gameConfig: "app.data",
    dispatcher: "core.dispatcher",
    eventProvider: "core.eventProvider",
    runtimeData: "core.runtimeData"
};
//# sourceMappingURL=TypesCore.js.map